import { StandardQuizQuestion } from '@/types/quizTypes';

export const UNITY_FUNDAMENTALS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "unity-fund-1",
    question: "What is a GameObject in Unity?",
    options: [
      "A script file",
      "The fundamental object in Unity scenes that represents characters, props, and scenery",
      "A 3D model format",
      "A physics calculation"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "GameObjects are the fundamental building blocks in Unity. Everything in a scene is a GameObject, from characters to cameras to lights.",
    category: "gameobjects",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-2",
    question: "What are Components in Unity?",
    options: [
      "Separate Unity projects",
      "Functional pieces attached to GameObjects that define behavior and properties",
      "Audio files",
      "Network protocols"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Components are modular pieces of functionality attached to GameObjects (Transform, Rigidbody, Scripts, etc.). GameObjects are containers for Components.",
    category: "components",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-3",
    question: "What is a Prefab in Unity?",
    options: [
      "A texture file",
      "A reusable GameObject template that can be instantiated multiple times",
      "A level design tool",
      "A rendering setting"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Prefabs are GameObject templates that can be reused and instantiated throughout your project. Changes to a prefab affect all instances.",
    category: "prefabs",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-4",
    question: "What does the Transform component control?",
    options: [
      "GameObject color",
      "Position, rotation, and scale of a GameObject",
      "Physics simulation",
      "Audio playback"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Every GameObject has a Transform component that defines its position (x,y,z), rotation (quaternion/euler), and scale in world or local space.",
    category: "transform",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-5",
    question: "What is the purpose of a Rigidbody component?",
    options: [
      "Render 3D models",
      "Enable physics simulation for GameObjects",
      "Play animations",
      "Handle input"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Rigidbody components enable GameObjects to be affected by physics (gravity, forces, collisions). Use Rigidbody for dynamic physics-driven objects.",
    category: "physics",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-6",
    question: "What do Colliders do in Unity?",
    options: [
      "Detect physics collisions and triggers",
      "Render shadows",
      "Control camera movement",
      "Manage memory"
    ],
    correctAnswer: 0,
    correctAnswerIndex: 0,
    difficulty: "medium",
    explanation: "Colliders define the physical boundaries of GameObjects for collision detection. Types include BoxCollider, SphereCollider, MeshCollider. Can be triggers or physical colliders.",
    category: "physics",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-7",
    question: "What scripting language is primarily used in Unity?",
    options: [
      "Python",
      "C#",
      "JavaScript",
      "Lua"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Unity uses C# for scripting. Scripts inherit from MonoBehaviour and can access Unity's API for game logic, physics, rendering, and more.",
    category: "scripting",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "unity-fund-8",
    question: "What is the Unity Scene?",
    options: [
      "A video cutscene",
      "A container for game environments where you place GameObjects",
      "A physics engine",
      "An audio mixer"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Scenes are the environments where you build your game. They contain all GameObjects for a level, menu, or game state. Projects can have multiple scenes.",
    category: "scenes",
    points: 10,
    type: "multiple-choice"
  }
];

export const generateUnityFundamentalsQuiz = () => ({
  questions: UNITY_FUNDAMENTALS_QUIZ,
  passThreshold: 75,
  timeLimit: 600,
  category: 'unity-basics'
});
